import { FC, Fragment } from "react";
import React from "react";
import { FormControl, RadioGroup } from "@material-ui/core";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { useStyles } from "../../useStyles";
import { FormControlLabel } from "../core/FormControlLabel";
import { Radio } from "../core/Radio";

export const ModificationPowerOverheadRoofPillarReassemblyLocationForm: FC = () => {
    const classes = useStyles();
    const { values, setValues } = useFormModel<
        ChangeNames.MODIFICATION_POWER_OVERHEAD_ROOF_PILLAR_REASSEMBLY_LOCATION
    >();

    const convertValue = (): string => {
        if (values.modificationPowerOverheadRoofPillarReassemblyLocation.value.other)
            return "other";
        if (values.modificationPowerOverheadRoofPillarReassemblyLocation.value.same) return "same";
        return "";
    };
    const selection = convertValue();

    return (
        <Fragment>
            <div className={classes.container}>
                <h4 className={classes.h4} style={{ marginBottom: 0, marginTop: 40 }}>
                    Montage Dachständer
                </h4>
                <p className={classes.p}>
                    An welcher Stelle soll der Dachständer wieder montiert werden?
                </p>{" "}
                <FormControl component="fieldset" style={{ display: "flex" }}>
                    <RadioGroup
                        value={selection}
                        onChange={(e, v) => {
                            setValues(values => {
                                values.modificationPowerOverheadRoofPillarReassemblyLocation.value = {
                                    other: v.indexOf("other") >= 0,
                                    same: v.indexOf("same") >= 0,
                                };
                            });
                        }}
                    >
                        <FormControlLabel
                            value="same"
                            control={<Radio />}
                            label="Gleicher Stelle"
                            text=""
                            error={
                                values.modificationPowerOverheadRoofPillarReassemblyLocation
                                    .error != null
                            }
                        />
                        <FormControlLabel
                            value="other"
                            control={<Radio />}
                            label="Anderer Stelle"
                            error={
                                values.modificationPowerOverheadRoofPillarReassemblyLocation
                                    .error != null
                            }
                        />
                    </RadioGroup>
                </FormControl>
            </div>
        </Fragment>
    );
};
